import { render, staticRenderFns } from "./EntityInformations.vue?vue&type=template&id=70505700"
import script from "./EntityInformations.vue?vue&type=script&lang=js"
export * from "./EntityInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports